export const Footer = (props) => {
    return (
        <footer id="footer" className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-7"> 
 
              <p className="adrs-hd">We are an independent RO service provider and take pride in being one of the fastest-growing service centers in the industry. Our expert team specializes in RO servicing, AMC, repairs, and maintenance, delivering reliable and professional care for your water purification systems. Please note that we are not associated with or authorized by any specific brand or company. We take full responsibility for all services provided and remain committed to your complete satisfaction.</p>
            </div>
            <div className="col-md-5">
              
              <p className="copy-ryt"><span>Copyright © 2024 All right reserved. &nbsp;&nbsp; | &nbsp;&nbsp; <a href="/privacy-policies" target="_blank">Privacy Policy</a></span></p>
            </div>
          </div>
        </div>
      </footer>
    )
}